<template>
	<db-row 
		el="button" 
		type="button"
		ref="btn" 
		class="button-wrapper ovh" 
		valign="middle" 
		align="center" 
		:height="btnHeight"
		:width="width" 
		:disabled="disabled"
		:class="btnClass"
		@click="click"
	>
		<db-col class="btn-inner-wrapper" :class="'btn-inner-wrapper-' + lock" :width="width">
			<db-col class="ft-32" :class="plain ? '' : 'ft-bold'" valign="middle" align="center" v-if="!lock">
				<db-icon width="auto" height="100%" :icon="prefixIcon" v-if="prefixIcon" class="btn-prefix-icon" />
				<slot />
				<db-icon width="auto" height="100%" :icon="suffixIcon" v-if="suffixIcon && !fetch" class="btn-suffix-icon" />
				<db-icon width="auto" height="100%" :icon="arrIcon" size="36" v-if="fetch" class="btn-suffix-icon" />
			</db-col>
			
			<db-col class="animation-boxer ovh" valign="middle" align="center" v-else>
				<db-icon icon="loading" class="loading-animation" circle />
				请稍后
			</db-col>
		</db-col>
	</db-row>
</template>

<script>
	import {ButtonTypes, ButtonSizeTypes} from '../../../../enum'
	
	export default {
		name: 'button_',
		
		props: {
			width: {
				type: [String, Number],
				default: 'auto'
			},
			
			height: {
				type: [String, Number],
				default: '88'
			},
			
			disabled: {
				type: Boolean,
				default: false
			},
			
			type: {
				type: String,
				default: 'primary'
			},
			
			plain: {
				type: Boolean,
				default: false
			},
			
			around: {
				type: Boolean,
				default: false
			},
			
			prefixIcon: {
				type: String,
				default: ''
			},
			
			suffixIcon: {
				type: String,
				default: ''
			},
			
			loading: {
				type: [Boolean, String, Number, Function],
				default: 0
			},
			
			size: {
				type: String,
				default: ''
			},
			
			fetch: {
				type: [Array, Function, Promise]
			},
			
			fetchValue: {
				type: [String, Number, Boolean],
				default: ''
			},
			
			fetchHandler: {
				type: Function
			}
		},
		
		data(){
			return {
				lock: false,
				timer: null,
				combox: false
			}
		},
		
		computed: {
			arrIcon(){
				return this.combox ? 'arr-up' : 'arr-down'
			},
			
			btnClass(){
				if(this.type && this.type.toUpperCase() in ButtonTypes){
					const styleType = 'btn-' + this.type + '-' + this.plain
					const styleSize = "btn-size-" + this.size.toLowerCase()
					const styleAround = 'btn-around-' + this.around
					const styleDisabled = 'btn-disabled-' + this.disabled
					const styleLoading = 'btn-loading-' + this.lock
					return [styleType, (this.size ? styleSize : ''), styleAround, styleLoading, styleDisabled]
				}
			},
			
			btnHeight(){
				let height = this.height
				if(this.size){
					switch(this.size.toUpperCase()){
						case ButtonSizeTypes.LARGE: {
							height = 112
							break
						};
						case ButtonSizeTypes.MEDIUM: {
							height = 96
							break
						};
						case ButtonSizeTypes.SMALL: {
							height = 80
							break
						};
					}
				}
				return height
			}
		},
	
		methods: {
			click(){
				if(this.loading){
					const loadingType = typeof this.loading
					if(this.lock === false){
						this.lock = true
						if(loadingType === 'string' || loadingType === 'number'){
							const timeout = (this.loading !== undefined && this.loading !== null) ? parseInt(this.loading) : 30 * 1000
							this.$emit('click', () => {
								this.lock = false
							})
							setTimeout(() => {
								this.lock = false
							}, timeout)
						}else if(loadingType === 'boolean'){
							this.$emit('click', () => {
								this.lock = false
							})
						}
					}
				}else{
					if(this.fetch){
						this.combox = true
						this.$picker({
							title: '请选择',
							props: {
								columns: this.fetch,
								value: this.fetchValue,
								on: {
									close: () => {
										this.combox = false
									}
								}
							},
							handler: value => {
								this.combox = false
								this.fetchHandler && this.fetchHandler(value)
							}
						}, this)
					}else{
						this.$emit('click')
					}
				}
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	@import '../../../../assets/styles/vars.scss';
	
	.button-wrapper{
		postion: relative;
		border-radius: $btn_radius;
		border: solid 2px transparent;
		background: #fff;
		color: #333;
		padding: 0 32px;
		font-size: 28px;
		
		&.btn-primary-true{
			background: transparent;
			color: $btn_primary_color;
			border: solid 2px $btn_primary_color;
		}
		&.btn-primary-false{
			background: $btn_primary_color;
			color: #fff;
		}
		
		&.btn-text-true{
			background: transparent;
			color: #2e7bfd;
			border: solid 2px transparent;
		}
		&.btn-text-false{
			background: transparent;
			color: #2e7bfd;
		}
		
		&.btn-danger-true{
			background: transparent;
			color: $btn_danger_color;
			border: solid 2px $btn_danger_color;
		}
		&.btn-danger-false{
			background: $btn_danger_color;
			color: #fff;
		}
		
		&.btn-info-true{
			background: transparent;
			color: $btn_text_lighter_color;
			border: solid 2px $btn_text_lighter_color;
		}
		&.btn-info-false{
			background: $btn_text_lighter_color;
			color: #fff;
		}
		
		&.btn-success-true{
			background: transparent;
			color: $btn_success_color;
			border: solid 2px $btn_success_color;
		}
		&.btn-success-false{
			background: $btn_success_color;
			color: #fff;
		}
		
		&.btn-around-true{
			border-radius: 1000px;
		}
		
		&.btn-size-large{
			font-size: 40px;
		}
		&.btn-size-medium{
			font-size: 32px;
		}
		&.btn-size-small{
			font-size: 28px;
		}
		
		/* &:active{
			transform: scale(.9);
		} */
		
		&.btn-disabled-true{
			background: #dedede;
			color: #999;
			font-style: italic;
			
			&.btn-primary-true{
				background: transparent;
				color: #999;
				border-color: #ccc;
			}
			
			&.btn-success-true{
				background: transparent;
				border-color: #ccc;
				color: #999;
			}
			
			&.btn-text-true{
				color: #999999;
			}
			&.btn-text-false{
				color: #999999;
			}
		}
		
		&.btn-loading-true{
			background: #dedede;
			color: #999;
			font-style: italic;
		}
		
		.btn-inner-wrapper{
			position: relative;
			transition: transform .4s;
			white-space: nowrap;
			font-size: inherit;
			
			.animation-boxer{
				.loading-animation{
					margin-right: 6px;
				}
			}
		}
		
		.btn-prefix-icon{
			margin-right: 12px;
		}
		.btn-suffix-icon{
			margin-left: 12px;
		}
	}
</style>


